// extracted by mini-css-extract-plugin
export default {"cls1":"InviteOTP-Container_cls1__cmK7P","cls2":"InviteOTP-Container_cls2__rEt8L InviteOTP-Container_cls1__cmK7P"};